export const DATE_FORMAT = 'dd MMM, yyyy';
export const DAY_TIME_FORMAT = 'd MMM, HH:mm';
export const DATE_TIME_FORMAT = 'dd MMM yyyy/HH:mm';
